"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function Eurocontrol() {
  const reduce = useReducedMotion();
  const headlineText = "Indústria de Snacks.";
  const words = headlineText.split(" ");
  const wordVariants = {
    hidden: reduce ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 24,
      filter: "blur(14px)"
    },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1] as const
      }
    }
  };
  return;
}